// 261005 E5 — MỘT khuôn thẻ đề xuất cho mọi chặng (thay viền trái 4px theo tone + `TONE_BORDER` lặp 6 file):
// viền mảnh bo 12 · tiêu đề đậm + trạng thái (chấm + chữ) · thân · chân kẻ mảnh (nút chính "Áp" + nút chữ).
import React from 'react';
import { Spin } from 'antd';
import { Pill } from '../WbSlot';

export type BlockTone = 'ok' | 'warn' | 'danger' | 'neutral';

export const BlockShell: React.FC<{ children: React.ReactNode }> = ({ children }) => <div className="wb-blk">{children}</div>;

const PILL: Record<BlockTone, 'ok' | 'warn' | 'todo' | 'bad'> = { ok: 'ok', warn: 'warn', danger: 'bad', neutral: 'todo' };

export const BlockBody: React.FC<{ title: string; tone: BlockTone; stateLabel?: string | null; running?: boolean; chip?: string | null; children?: React.ReactNode }> = ({
  title, tone, stateLabel, running, chip, children,
}) => (
  <>
    <div className={`wb-blk-head wb-blk-h-${tone}`}>
      <span className="wb-blk-title" style={{ wordBreak: 'break-word' }}>{title}</span>
      <span className="wb-blk-state">
        {running && <Spin size="small" />}
        {stateLabel && <Pill tone={PILL[tone]}>{stateLabel}</Pill>}
        {chip && <Pill tone="ind">{chip}</Pill>}
      </span>
    </div>
    <div className="wb-blk-body">{children}</div>
  </>
);

export const BlockFoot: React.FC<{ end?: React.ReactNode; children?: React.ReactNode }> = ({ end, children }) => (
  <div className="wb-blk-foot">
    {children}
    {end && <span className="wb-blk-end">{end}</span>}
  </div>
);
